import { z } from 'zod';
import { loadAllPages } from '@/utils/loadAllPages';
const vendorSchema = z.object({id:z.string(),name:z.string(),gstin:z.string().nullable().optional(),legalName:z.string().nullable().optional(),tradeName:z.string().nullable().optional(),paymentTerms:z.string().nullable().optional()}).passthrough();
export type VendorOption = z.infer<typeof vendorSchema>;
/** Load the complete selector through supported page sizes; never expose a partial list. */
export async function loadVendorOptions(signal: AbortSignal): Promise<VendorOption[]> {
  const rows = await loadAllPages('/vendors', signal, { label: 'Supplier', requirePagination: true });
  return rows.map((r) => vendorSchema.parse(r));
}
